import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentCard = _resolveComponent("ContentCard")!

  return (_openBlock(), _createBlock(_component_ContentCard, null, {
    heading: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString($props.pageTitle), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: $props.pageContent,
        class: "flow"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}